import holy from './holy'
import protection from './protection'
import retribution from './retribution'

const paladin = { specs: [holy, protection, retribution] }

export default paladin
